import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IRelatorioInformaticaBody } from 'src/app/interfaces/relatorio/Informatica/IRelatorioInformaticaBody';
import { IRelatorioInformaticaResponseData } from 'src/app/interfaces/relatorio/Informatica/IRelatorioInformaticaResponseData';

@Injectable({
  providedIn: 'root'
})
export class RelatorioInformaticaService {
  private readonly baseURL = '/RelatorioInformatica';

  constructor(private httpClient: HttpClient) {}

  postRelatorioInformatica(body: IRelatorioInformaticaBody) {
    return this.httpClient.post<
      IApiResponse<IRelatorioInformaticaResponseData>
    >(this.baseURL, body);
  }
}
